export interface MdrPassenger {
  relation: 'REQUESTER' | 'SAME_CABIN' | 'SAME_BOOKING' | 'DINING_WITH' | 'EXTRA_CABIN' | 'SAME_BOOKING_EXTRA' | 'DINING_WITH_EXTRA';
  booking_number: string;
  cabin: string;
  occupant_name?: string | null;
  dining_with_code: string;
  language: string;
  passenger_name: string;
  status: 'UNCHANGED' | 'EXCLUDED' | 'ADDED';
}

export interface MdrRequestPassengers {
  mdr_request_id: string;
  total_diners: number;
  passengers: MdrPassenger[];
  detached_cabins: string[];
  booking_number: string;
  passenger_name: string;
}

export interface MdrOpenRequest {
  mdr_request_id: string;
  request_datetime: string;
  ship_id: string;
  ship_name: string;
  booking_number: string;
  cabin: string;
  passenger_name: string;
  restaurant: string;
  original_shift: string;
  requested_shift: string;
  total_diners: number;
  embark_date: string;
  disembark_date: string;
  language: string;
  status?: 'MDR_PENDING' | 'MDR_ACCEPTED' | 'MDR_REJECTED';
}

export interface MdrPagination {
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

/** Generic paginated envelope shared by every MDR list endpoint. */
export interface MdrPaginatedResponse<T> {
  data: T[];
  pagination: MdrPagination;
}

export type MdrResponse = MdrPaginatedResponse<MdrOpenRequest>;

// --- Restaurants & shifts (FUN6 — Cap. 2.2.6) ------------------------------

/** Shift as returned in the restaurant LIST row (code + dinner window). */
export interface ShiftListItem {
  code: string;
  dinner_start: string; // HH:MM
  dinner_end: string;   // HH:MM
}

/** Shift (turno) as sent in a create/update restaurant body. */
export interface ShiftBody {
  /** Present only when updating an existing shift; omit to add a new one. */
  id?: number;
  code: string;
  start: string; // HH:MM
  end: string;   // HH:MM
}

/** Shift (turno) as returned in restaurant detail responses. */
export interface ShiftDetail {
  id: number;
  code: string | null;
  start: string; // HH:MM
  end: string;   // HH:MM
}

/** Request body for creating or updating a restaurant. */
export interface RestaurantBody {
  code: string;
  name: string;
  ship: string;
  shifts: ShiftBody[];
}

/** Restaurant row returned in the paginated list. */
export interface RestaurantListItem {
  id: number;
  code: string;
  name: string;
  ship_id: string;
  ship_name: string;
  /** Shifts ordered by start time, each carrying code + dinner window. */
  shifts: ShiftListItem[] | null;
}

/** Full restaurant object with shift list, returned by GET/POST/PUT. */
export interface RestaurantDetail {
  id: number;
  code: string;
  name: string;
  ship_id: string;
  ship_name: string;
  shifts: ShiftDetail[];
}

export type RestaurantListResponse = MdrPaginatedResponse<RestaurantListItem>;

/** Result of the PENDING MDR conflict check for a (ship, restaurant code, stage) tuple. */
export interface ConflictCheckResponse {
  conflict: boolean;
}
